import invariant from 'tiny-invariant'
import { BigNumberish } from 'ethers'
import { RoutePlanner, CommandType } from '../../utils/routerCommands'
import { encodeInputTokenOptions, Permit2Permit } from '../../utils/inputTokens'
import { Command, RouterActionType, TradeConfig } from '../Command'
import { ROUTER_AS_RECIPIENT, SAMB_ADDRESS } from '../../utils/constants'

export class UnwrapSAMB implements Command {
  readonly tradeType: RouterActionType = RouterActionType.UnwrapSAMB
  readonly permit2Data: Permit2Permit
  readonly sambAddress: string
  readonly amount: BigNumberish

  constructor(amount: BigNumberish, chainId: number, permit2?: Permit2Permit) {
    this.sambAddress = SAMB_ADDRESS(chainId)
    this.amount = amount

    if (!!permit2) {
      invariant(
        permit2.details.token.toLowerCase() === this.sambAddress.toLowerCase(),
        `must be permitting SAMB address: ${this.sambAddress}`
      )
      invariant(permit2.details.amount >= amount, `Did not permit enough SAMB for unwrapSAMB transaction`)
      this.permit2Data = permit2
    }
  }

  encode(planner: RoutePlanner, _: TradeConfig): void {
    encodeInputTokenOptions(planner, {
      permit2Permit: this.permit2Data,
      permit2TransferFrom: {
        token: this.sambAddress,
        amount: this.amount.toString(),
      },
    })
    planner.addCommand(CommandType.UNWRAP_SAMB, [ROUTER_AS_RECIPIENT, this.amount])
  }
}
